// apps/client/src/game/testFinders/core.ts — the M0 finder kinds for `__wt.find` (§8.11)
import type { Vec2 } from '@whiskerton/shared';
import type { TestFinder } from '../testHooks';

const nearest = <T extends { x: number; y: number }>(list: readonly T[], near: Vec2 | null): T | null =>
  [...list].sort((a, b) => (near ? Math.hypot(a.x - near.x, a.y - near.y) - Math.hypot(b.x - near.x, b.y - near.y) : 0))[0] ?? null;

export const finders: readonly TestFinder[] = [
  { kind: 'door', find: (g, near) => {
    const m = g.map;
    if (!m) return null;
    const doors = [{ id: 'shop', ...m.sites.shopDoor }, { id: 'museum', ...m.sites.museumDoor }, ...m.plots.map((p) => ({ id: `plot${p.index}`, ...p.door }))];
    return nearest(doors, near);
  } },
  { kind: 'dropbox', find: (g) => (g.map ? { id: 'dropbox', ...g.map.sites.dropBox } : null) },
  { kind: 'board', find: (g) => (g.map ? { id: 'board', ...g.map.sites.board } : null) },
  { kind: 'mailbox', find: (g, near) => nearest(g.objects('mailbox').map((o) => ({ id: o.id as string, x: o.x, y: o.y })), near) },
  { kind: 'tree', find: (g, near) => nearest(g.objects('tree').map((o) => ({ id: o.id as string, x: o.x, y: o.y })), near) },
  { kind: 'resident', find: (g, near) => nearest(g.remotePositions().map((p) => ({ id: p.id as string, x: p.x, y: p.y })), near) },
];
